// room store
import {observer} from '@/plugins/vue-multichannel-scoketio/'

const state = {
  scale    : 100,
  scaleMax : 200,
  position : { x: 0, y: 0 }
}

const getters = {
  scale    : state => state.scale,
  scaleMax : state => state.scaleMax,
  position : state => state.position
}

const mutationSockets = {
  SOCKET_changeScale (state, value) {
    if (value <= state.scaleMax) {
      state.scale = value
    } else {
      state.scale = state.scaleMax
    }
  },
  SOCKET_movePosition (state, {x, y}) {
    state.position.x = x
    state.position.y = y
  },
  SOCKET_zoomPoint (state, {scale, position: {x, y}}) {
    if (scale <= state.scaleMax) {
      state.scale = scale
      state.position.x = x
      state.position.y = y
    } else {
      state.scale = state.scaleMax
    }
  }
}

const mutations = {
  changeScale (state, value) {
    if (value <= state.scaleMax) {
      state.scale = value
    } else {
      state.scale = state.scaleMax
    }
  },
  movePosition (state, {x, y}) {
    state.position.x = x
    state.position.y = y
  },
  zoomPoint (state, {scale, position: {x, y}}) {
    if (scale <= state.scaleMax) {
      state.scale = scale
      state.position.x = x
      state.position.y = y
    } else {
      state.scale = state.scaleMax
    }
  },
  ...mutationSockets
}

const actions = {
  sendChangeScale ({commit}, data) {
    commit('changeScale', data)
    observer.of('/').emit('changeScale', data)
  },
  sendMovePosition ({commit}, data) {
    commit('movePosition', data)
    observer.of('/').emit('movePosition', data)
  },
  sendZoomPoint ({commit}, data) {
    commit('zoomPoint', data)
    observer.of('/').emit('zoomPoint', data)
  },
  changeScale ({commit}, data) {
    commit('changeScale', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/room/store/index.js